var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 13.6654C3.31798 13.6654 0.333313 10.6807 0.333313 6.9987C0.333313 3.3167 3.31798 0.332031 6.99998 0.332031C10.682 0.332031 13.6666 3.3167 13.6666 6.9987C13.6666 10.6807 10.682 13.6654 6.99998 13.6654ZM6.99998 12.332C8.41447 12.332 9.77102 11.7701 10.7712 10.7699C11.7714 9.76974 12.3333 8.41319 12.3333 6.9987C12.3333 5.58421 11.7714 4.22766 10.7712 3.22746C9.77102 2.22727 8.41447 1.66536 6.99998 1.66536C5.58549 1.66536 4.22894 2.22727 3.22874 3.22746C2.22855 4.22766 1.66665 5.58421 1.66665 6.9987C1.66665 8.41319 2.22855 9.76974 3.22874 10.7699C4.22894 11.7701 5.58549 12.332 6.99998 12.332ZM6.99998 10.332C6.11592 10.332 5.26808 9.98084 4.64296 9.35572C4.01784 8.7306 3.66665 7.88275 3.66665 6.9987C3.66665 6.11464 4.01784 5.2668 4.64296 4.64167C5.26808 4.01655 6.11592 3.66536 6.99998 3.66536C7.88403 3.66536 8.73188 4.01655 9.357 4.64167C9.98212 5.2668 10.3333 6.11464 10.3333 6.9987C10.3333 7.88275 9.98212 8.7306 9.357 9.35572C8.73188 9.98084 7.88403 10.332 6.99998 10.332Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBlue);
export default __webpack_public_path__ + "static/media/single-blue.744a4bde70680815325c4205999560ae.svg";
export { ForwardRef as ReactComponent };